import { render, staticRenderFns } from "./FmaLookahead.vue?vue&type=template&id=7f52857c"
import script from "./FmaLookahead.vue?vue&type=script&lang=js"
export * from "./FmaLookahead.vue?vue&type=script&lang=js"
import style0 from "./FmaLookahead.vue?vue&type=style&index=0&id=7f52857c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports